module.exports = __webpack_public_path__ + "static/media/file-word.f8d11c70.svg";